import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Modal from 'react-modal'
import PhoneInput from 'react-phone-number-input/input'

import CreditCardPayment from 'components/CreditCardPayment'

import {
  ChoiceField,
  CouponCodeField,
  TextField,
  PrivacyPolicyCheck,
} from 'components/Inputs'
import { SelectField } from './Inputs'
import CountrySelect from './PhoneCountrySelect'
import classNames from 'classnames'

class CartInfos extends React.Component {
  constructor(props) {
    super(props)

    this.createMetaField = this.createMetaField.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    this.state = {
      country: 'IT',
      showModal: false,
      submitting: false,
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      focused: '',
      errors: {},
    }
  }

  onSubmit(e) {
    e.preventDefault()
    const { paymentDisabled, stripe } = this.props

    this.setState({ submitting: true })

    if (paymentDisabled) {
      return this.commonSubmitProgress()
    }

    stripe.createPaymentMethod('card', {
      billing_details: { name: this.state.name },
    }).then((result) => {
      if (result.error) {
        this.setState({ errors: { card: result.error.message }, submitting: false })
      } else {
        this.commonSubmitProgress(result)
      }
    })
  }

  handleServerResponse(response) {
    if (response.err) {
      this.setState({ errors: response.err.fields, submitting: false })
      // Show error from server on payment form
    } else if (response.requires_action) {
      // Use Stripe.js to handle required card action
      this.props.stripe.handleCardAction(
        response.payment_intent_client_secret
      ).then((result) => {
        if (result.error) {
          this.setState({ errors: { card: result.error.message }, submitting: false })
          // Show error in payment form
        } else {
          // The card action has been handled
          // The PaymentIntent can be confirmed again on the server
          this.commonSubmitProgress(result)
        }
      })
    } else {
      this.props.updateCart({ step: 'end' })
      // Show success message
    }
  }

  commonSubmitProgress(token = {}) {
    const { cartOperation, cart, resourceId } = this.props

    cartOperation(
      resourceId,
      Object.assign({}, { token }, cart.data)
    ).then((response) => {
      return this.handleServerResponse(response)
    }).catch((err) => {
      return this.handleServerResponse(err)
    })
  }

  openModal(e) {
    e.preventDefault()
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  createMetaField(metaData, i) {
    const { type, title, required, label, options } = metaData
    const onChange = this.props.updateCart

    switch (type) {
    case 'checkbox':
    case 'radio':
      return (
        <ChoiceField
          data={this.props.cart}
          onChange={onChange}
          fieldLabel={label}
          field={`meta_${title}`}
          options={options}
          type={type}
          errors={this.state.errors}
          key={i}
          required={required}
        />
      )
    case 'select':
      return (
        <SelectField
          data={this.props.cart}
          onChange={onChange}
          fieldLabel={label}
          field={`meta_${title}`}
          options={options}
          errors={this.state.errors}
          key={i}
          required={required}
        />
      )
    case 'text':
    default:
      return (
        <TextField
          data={this.props.cart}
          onChange={onChange}
          fieldLabel={label}
          field={`meta_${title}`}
          errors={this.state.errors}
          key={i}
          required={required}
        />
      )
    }
  }

  render() {
    const {
      cart,
      paymentDisabled,
      metaData,
      company,
      updateCart,
      paymentInfo,
      disableAuth,
      disableCoupon,
      finishButtonText,
      topComponent,
    } = this.props
    const translationId = `app.cart.step.${cart.step}.title`
    const { submitting } = this.state

    const otherInputFields = Array.isArray(metaData) && metaData.length
      ? metaData.map(this.createMetaField)
      : null
    const creditCardField = !paymentDisabled
      ? (
        <CreditCardPayment
          onChange={(state => {
            this.setState(state)
          })}
          errors={this.state.errors}
        />
      )
      : null
    const top = topComponent
      ? (<div className="space--bottom-2">{ topComponent }</div>)
      : null

    return (
      <div className="reservation-step">
        <h1 className="reservation-step__title">
          <FormattedMessage id={translationId} />
          {/* <a href="#" onClick={this.openModal.bind(this)}>
          <i className="icon--info"></i>
        </a> */}
        </h1>
        <div className="reservation-step__content">
          { top }
          <form className="form" onSubmit={this.onSubmit} autoComplete="new-password">
            <div className="grid">
              <div className="grid__item lap-6-12 space--bottom-1">
                <h2 className="beta space--bottom-1">
                  <FormattedMessage id="app.cart.step.infos.personal-data" />
                </h2>
                <TextField
                  data={cart}
                  onChange={updateCart}
                  translationId="app.cart.step.infos.fields.first_name"
                  field="first_name"
                  errors={this.state.errors}
                />
                <TextField
                  data={cart}
                  onChange={updateCart}
                  translationId="app.cart.step.infos.fields.last_name"
                  field="last_name"
                  errors={this.state.errors}
                />
                <TextField
                  data={cart}
                  onChange={updateCart}
                  translationId="app.cart.step.infos.fields.email"
                  field="email"
                  errors={this.state.errors}
                  type="email"
                />
                <TextField
                  data={cart}
                  onChange={updateCart}
                  translationId="app.cart.step.infos.fields.repeat_email"
                  field="repeat_email"
                  errors={this.state.errors}
                  type="email"
                />
                { disableAuth && (
                  <div>
                    <label className="form__label">
                      <span>{'* '}</span><FormattedMessage id="app.cart.step.auth.fields.phone" />
                    </label>
                    <CountrySelect
                      className="form__input space--bottom-1"
                      locale={cart.data.ui_language}
                      value={this.state.country}
                      onChange={(country) => this.setState({ country })}
                    />
                    <PhoneInput
                      className={classNames('form__input space--bottom-1', {
                        'form__field--invalid': this.state.errors && this.state.errors.phone,
                      })}
                      onChange={(phone) => updateCart({ data: { phone } })}
                      country={this.state.country}
                      international
                      withCountryCallingCode
                      value={cart.data.phone}
                      placeholder="e.g. 636 555 0113"
                      required
                    />
                  </div>
                )}
                {
                  !disableCoupon && <CouponCodeField errors={this.state.errors} />
                }
                { otherInputFields && (
                  <div className="space--both-1">
                    <h2 className="beta space--bottom-1">
                      <FormattedMessage id="app.cart.step.infos.other-data" />
                    </h2>
                    { otherInputFields }
                  </div>
                )}
                { creditCardField }
                <PrivacyPolicyCheck company={company} />
              </div>
              <div className="grid__item lap-6-12">
                { paymentInfo }
              </div>
              <div className="grid__item form__actions">
                <button
                  type="submit"
                  disabled={submitting}
                  id="button--checkout"
                  className="button--primary button--large"
                >
                  <FormattedMessage id={finishButtonText} />
                </button>
              </div>
            </div>
            <Modal
              isOpen={this.state.showModal}
              onRequestClose={this.closeModal}
            >
              { paymentInfo }
            </Modal>
          </form>
        </div>
      </div>
    )
  }
}

CartInfos.propTypes = {
  cart: PropTypes.object.isRequired,
  updateCart: PropTypes.func.isRequired,
  cartOperation: PropTypes.func.isRequired,
  stripe: PropTypes.object.isRequired,
  paymentDisabled: PropTypes.bool,
  paymentInfo: PropTypes.object.isRequired,
  resourceId: PropTypes.string,
  metaData: PropTypes.array,
  company: PropTypes.string.isRequired,
  disableAuth: PropTypes.bool,
  disableCoupon: PropTypes.bool,
  finishButtonText: PropTypes.string.isRequired,
  topComponent: PropTypes.node,
}

export default CartInfos
